import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, carrierValidations } from "./carrier-schema";
import { getCarrier, editCarrier } from "services/data.internal.service";
import CarrierInfo from "./components/CarrierInfo";

function EditCarrier() {
  const location = useLocation();
  const { carrierCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const queryClient = useQueryClient();

  useQuery({
    queryKey: ["carrier", { carrierCode }],
    queryFn: () => getCarrier({ carrierCode }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editCarrierMutation = useMutation(editCarrier, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(carrierValidations),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    editCarrierMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["carrier"]),
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CarrierInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty} url="/setup/carrier" />
      </form>
    </Layout>
  );
}

export default EditCarrier;
